<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount} from 'svelte';
    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import Button from '../Button.svelte';
    import Modal from '../Modal.svelte';
    import yup from 'yup';
    import { sgettext } from '../../i18n.js';
    import { get, submit } from '../../utils.js';
    import {
        draftElementDetails,
        elementDetails,
        elementInstance,
        branchId,
        roles,
        selectedSequence,
        standaloneEdit,
        activityVersion
    } from '../Workspaces/workspacesStore.js';
    import ElementTypeMigrationConfirmationDisplayTable from './ElementTypeMigrationConfirmationDisplayTable.svelte';
    import {clearSelectedListItems, clearSequenceListSelection, setSelectedElements, updateLocalWorksequence,
        updateLocalElementInstance, removeLocalElementInstance, getLocalElementInstance} from '../Workspaces/RoleSequenceList/utils.js';

    export let element = null;
    let elementTypeMigrationUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/{elementId}/element_type_migration/`;
    let hazardOptionsApi = `${PATH_PREFIX}/sw/api/applicable-material-risks/`;
    const modalID = 'elementTypeMigrationModalID';
    const modalTitle = sgettext('$$CHANGE_ELEMENT_TYPE$$');
    let saving = false;
    let materialRiskSelectionRequired = false;
    let materialRiskModalID = 'elementTypeSafetyMaterialRiskModal';
    let newElementVersionID = null;
    let loadingHazardOptions = false;
    let globalHazardId = null;
    let globalControlId = null;
    let globalHazard = {id: ''};
    let globalControl = {id: ''};
    let hazardOptions = [];
    let controlOptions = [];

    async function getHazardOptions() {
        loadingHazardOptions = true;

        const response = await get(`${hazardOptionsApi}${$branchId}/`);

        if (response) {
            hazardOptions = await response.json();
        }

        loadingHazardOptions = false;
    }

    onMount(async () => {
        await getHazardOptions();
    });

    function getHazardFromId() {
        return hazardOptions.filter(o => o.id === globalHazardId)[0];
    }

    async function handleHazardChanged() {
        globalControl = {id: ''};
        globalControlId = null;

        if (globalHazardId) {
            let matching_hazard = getHazardFromId();
            controlOptions = matching_hazard.global_controls;
            globalControl = {id: ''};
            globalControlId = null;
        }
    }

    async function handleControlChanged() {
    }

    const schema = yup.object().shape({
        global_hazard: yup.number()
                .required(sgettext('$$REQUIRED_FIELD$$'))
                .typeError(sgettext('$$REQUIRED_FIELD$$')),
        global_control: yup.number()
                .required(sgettext('$$REQUIRED_FIELD$$'))
                .typeError(sgettext('$$REQUIRED_FIELD$$'))
    });

    $: elementType = element.type;
    export let newElementType = 'KNACK';

    async function handleSave() {
        if (newElementType === 'SAFETY' && globalHazardId == null && globalControlId == null) {
            jQuery(`#${modalID}`).modal('hide');
            materialRiskSelectionRequired = true;
            jQuery(`#${materialRiskModalID}`).modal('show');
        }
        else {
            saving = true;

            const url = `${elementTypeMigrationUrl.replace('{elementId}', element.elementId)}`;


            let payload = {
                element_type: `${newElementType}`,
                global_hazard: globalHazardId,
                global_control: globalControlId,
            };

            if (!$standaloneEdit) {
                payload.work_sequence_id = $elementInstance.worksequenceId;
                payload.element_instance = $elementInstance;
                payload.activityVersion = $activityVersion;
            }

            let method = 'POST';
            const resp = await submit(url, method, payload);

            if (resp.ok) {
                let result = await resp.json();  // returns a serialized list of element_instances in the selected work sequence
                elementDetails.set(result.element_element_version);
                draftElementDetails.set(result.element_element_version);

                if ($standaloneEdit)  {
                    jQuery(`#${modalID}`).modal('hide');
                    jQuery(`#${materialRiskModalID}`).modal('hide');
                    window.location.href = `${PATH_PREFIX}/sw/elements_database/${result.element_element_version.elementId}/#edit`;
                    return
                } else {
                    clearSelectedListItems($roles);
                    elementInstance.set({
                        roleId: result.new_element_instances[0].role_id,
                        worksequenceId: result.new_element_instances[0].worksequence_id,
                        id: result.new_element_instances[0].element_instance.id,
                        name: result.new_element_instances[0].element_instance.name,
                        versions: result.new_element_instances[0].element_instance.versions,
                        actionId: result.new_element_instances[0].element_instance.action_id,
                        type: result.new_element_instances[0].element_instance.type,
                    });
                    elementDetails.set(result.element_element_version);

                    let updatedRoles = [...$roles];
                    for(const new_element_instance of result.new_element_instances){
                        updatedRoles = updateLocalElementInstance($roles,  new_element_instance.role_id,
                            new_element_instance.worksequence_id,
                            new_element_instance.element_instance.id,
                            new_element_instance.element_instance);

                        removeLocalElementInstance($roles, new_element_instance.role_id,
                            new_element_instance.worksequence_id, [new_element_instance.old]);
                    }

                    roles.set(updatedRoles);
                    const selectedElement = getLocalElementInstance($roles, $elementInstance.roleId, $elementInstance.worksequenceId, $elementInstance.id);
                    roles.set(setSelectedElements($roles, [selectedElement], selectedElement.id));

                    jQuery(`#${modalID}`).modal('hide');
                    jQuery(`#${materialRiskModalID}`).modal('hide');
                    materialRiskSelectionRequired = false;
                    globalHazardId = null;
                    globalControlId = null;
                }
            }
        }

        setTimeout(() => {saving = false}, 500);
    }

    async function handleMaterialRiskSave() {
        jQuery(`#${materialRiskModalID}`).modal('hide');
    }

    function handleCancel() {
        jQuery(`#${modalID}`).modal('hide');
        jQuery(`#${materialRiskModalID}`).modal('hide');
        materialRiskSelectionRequired = false;
        globalHazardId = null;
        globalControlId = null;
    }
</script>

<style>
    .loading:after {
        overflow: hidden;
        display: inline-block;
        vertical-align: bottom;
        animation: ellipsis steps(5, end) 1500ms infinite;
        content: "\2026"; /* ascii code for the ellipsis character */
        width: 0;
    }

    @keyframes ellipsis {
        to {
            width: 1.25em;
        }
    }
</style>

<Modal id={modalID} title={modalTitle}>
    <div slot="body">
        {#if saving}
            <p class="loading">{sgettext("$$CREATING_NEW_ELEMENT_ONE_MOMENT$$")}</p>
        {:else}
            {#if $activityVersion}
                <p>{sgettext('$$CREATE_DUPLICATE_ELEMENT_TYPE_1$$')}{newElementType}{sgettext('$$REPLACE_INSTANCES_ELEMENT_ACTIVITY_1$$')}</p>
                <ElementTypeMigrationConfirmationDisplayTable elementId={element.elementId} activityVersionId={$activityVersion['id']}/>
                <p>{sgettext('$$CONTENT_APPLICABLE_NEW_TYPE_TRANSFER$$')}</p>
                <p class="text-secondary">{sgettext('$$NOTE_DUPLICATE_ELEMENT_RESIDE_BRANCH_USE$$')}</p>
                <p class="font-weight-bold">{sgettext('$$CREATE_ELEMENT_TYPE_1$$')}{newElementType}{sgettext('$$EDIT_3$$')}</p>
            {:else}
                <p>{sgettext('$$CREATE_DUPLICATE_ELEMENT_TYPE_1$$')}{newElementType}{sgettext('$$RESIDE_BRANCH_1$$')} </p>
                <p>{sgettext('$$CONTENT_APPLICABLE_NEW_TYPE_TRANSFER$$')} </p>
                <p class="font-weight-bold">{sgettext('$$CREATE_ELEMENT_TYPE_1$$')}{newElementType}{sgettext('$$EDIT_3$$')}</p>
            {/if}
        {/if}
    </div>

    <div slot="footer">
        <Button type="primary"
                disabled={saving}
                name="{sgettext('$$NO$$')}"
                on:click={handleCancel} />
        <Button name="{sgettext('$$YES$$')}"
                disabled={saving}
                on:click={handleSave} />
    </div>
</Modal>

{#if element.evId}
    <Modal id={materialRiskModalID} title="{sgettext('$$MATERIAL_RISK$$')}" blockClose={true}>
        <div slot="body">
            {#if saving}
                <p class="loading">{sgettext("$$CREATING_NEW_ELEMENT_ONE_MOMENT$$")}</p>
            {/if}

            {#if loadingHazardOptions}
                <div>
                    <i class="fas fa-spinner fa-spin"></i>
                </div>
            {:else}
                <div class="form-group">
                    <ComboSelect
                            id="global_hazard"
                            label={sgettext("$$HAZARD_1$$")}
                            options={hazardOptions}
                            bind:value={globalHazardId}
                            on:changed={handleHazardChanged}
                            searchable={true}
                            {schema}/>
                </div>
                <div class="form-group">
                    <ComboSelect
                            id="global_control"
                            label={sgettext("$$CONTROL_1$$")}
                            options={controlOptions}
                            bind:value={globalControlId}
                            on:changed={handleControlChanged}
                            searchable={true}
                            {schema}/>
                </div>
            {/if}
        </div>
        <div slot="footer">
            <Button type="primary"
                    disabled={saving}
                    name="{sgettext('$$CANCEL$$')}"
                    on:click={handleCancel} />
            <Button name="{sgettext('$$SELECT$$')}"
                    disabled={saving}
                    on:click={handleSave} />
        </div>
    </Modal>
{/if}
